// Import and expose jQuery globally
import $ from 'jquery';
window.$ = window.jQuery = $;

// Import Slick Carousel
import 'slick-carousel';


$(document).ready(function () {


   $('.sliderteaser > .teasers').on('afterChange', function(event, slick, currentSlide){
         lazyLoadInstance.update();
    });

   $('.sliderteaser > .teasers').on('init', function(event, slick){
console.log("here");

         lazyLoadInstance.update();
    });

   $('.sliderthis').on('init', function(event, slick){
console.log("here");

         lazyLoadInstance.update();
    });


    $('.media-grid.layout-galleryslider').on('init', function(event, slick){
         lazyLoadInstance.update();

    });
let gallerysliderfirstTrigger = true;
$('.media-grid.layout-galleryslider').on('beforeChange', function(event, slick, currentSlide, nextSlide){

    if(gallerysliderfirstTrigger){

        setTimeout(function() {
                $('.media-grid.layout-galleryslider').css('visibility', 'visible');
                $('.media-grid.layout-galleryslider').addClass('shown');
            console.log("show slides");
          }, 500);

        gallerysliderfirstTrigger = false;
    }

});


  $('.sliderteaser > .teasers').slick({
         centerMode: true,
          centerPadding: '300px',
          slidesToShow: 2,
          arrows: false,
          focusOnSelect: true,
          slidesToScroll: 1,
          autoplay: false,
          initialSlide: 1,
          autoplaySpeed: 2000,
          responsive: [
                {
                  breakpoint: 991,
                  settings: {
                    initialSlide: 0,
                    slidesToShow: 1,
                    centerPadding: '0',
                  }
                },
            ]
      });


    $('.sliderthis').slick({
          slidesToShow: 5,
          centerMode: true,
          centerPadding: '0px',
          speed: 1000,
          arrows: false,
          dots: true,
          infinite: true,
          slidesToScroll: 1,
          autoplay: true,
          autoplaySpeed: 4000,
          responsive: [
                {
                  breakpoint: 991,
                  settings: {
                    slidesToShow: 3,
                  }
                },
                {
                  breakpoint: 767,
                  settings: {
                    slidesToShow: 2,
                  }
                },
                {
                  breakpoint: 500,
                  settings: {
                    slidesToShow: 1,
                  }
                }
            ]
    });





     $('.media-grid.layout-galleryslider').slick({
          slidesToShow: 2,
          arrows: false,
          lazyLoad: 'ondemand',
          focusOnSelect: true,
          speed: 1000,
          autoplay: true,
          autoplaySpeed: 4000,
          dots: true,
          infinite: true,
          slidesToScroll: 1,
          // prevArrow: '<button class="slick-prev" aria-label="Previous"></button>',
          // nextArrow: '<button class="slick-next" aria-label="Next"></button>',
      });

        //For Gallery slider
    $('.js-items-slider-container .slider-for').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        dots: false,
        fade: true,
        autoplay: true,
        asNavFor: '.js-items-slider-container .slider-nav'
    });
    $('.js-items-slider-container .slider-nav').slick({
        slidesToShow: 5,
        slidesToScroll: 1,
        asNavFor: '.js-items-slider-container .slider-for',
        dots: false,
        centerMode: false,
        focusOnSelect: true,
        arrows: true,
        prevArrow: "<i class='ri-arrow-left-s-line arrow-left'></i>",
        nextArrow: "<i class='ri-arrow-right-s-line arrow-right'></i>",
        responsive: [{
            breakpoint: 991,
            settings: {
                slidesToShow: 4,
            }
        }, {
            breakpoint: 767,
            settings: {
                slidesToShow: 3,
            }
        }],
    });


});